export type IntervalKey = "first" | "second";
export type FieldKey = "start" | "end";

export interface IntervalTime {
  start: number;
  end: number;
}

export interface ChimesTime {
  first: IntervalTime;
  second: IntervalTime;
}

export interface ClockChimeSettingsProps {
  deviceId: string;
  withCustomMusic: boolean;
  isAdmin: boolean;
}

export interface ClockChimeTimeInputProps {
  label?: string | null;
  value: number;
  maxHoursValue?: number;
  onChange: (hours: number) => void;
}

export interface ClockChimeSettingsParams {
  firstStartChimes: number;
  firstEndChimes: number;
  secondStartChimes: number;
  secondEndChimes: number;
  chimesMode: number;
  chimesScheme: number;
  christmasChimes: boolean;
  chimesSoundLevel: number;
}

export const SCHEMES = {
  0: "Куранты на Спасской башне Московского Кремля",
  1: "Куранты Сергиево-троицкая Лавра",
  2: "Лондонский Биг Бен",
  3: "Напольные часы",
  4: "Псково-Печерский монастырь",
  5: "Проигрыш и бой (без четвертей)",
  6: "Проигрыш и бой",
  7: "Проигрыш и бой (без четвертей)",
  8: "Проигрыш и бой (без четвертей)",
  9: "Проигрыш и бой (без четвертей)",
  10: "Уникальная программа"
};


export const MODES = {
  0: "Боя нет",
  1: "Только в 12",
  2: "Только в 12 и 18",
  3: "Каждый час",
  4: "Каждые полчаса",
  5: "Каждые 15 минут",
  6: "Только бой"
};
